import React, { FunctionComponent } from 'react';
import { CardContent } from '@companion-professional/components';

interface CheckupCardContentProps {
  children?: React.ReactNode;
}

export const CheckupCardContent: FunctionComponent<CheckupCardContentProps> = ({ children }) => {
  return <CardContent className="flex flex-1 flex-col items-center justify-start">{children}</CardContent>;
};
